import setMailListRowsFlagState from './setMailListRowsFlagState';
import { action } from 'satcheljs/lib/legacy';
import { listViewStore, MailRowDataPropertyGetter } from 'owa-mail-list-store';
/**
 * Get the flag status to be set
 * @param rowKeys the conversation rowkeys
 * @param tableViewId the table view
 * @return the flag status to be set
 */
function getFlagStatusToSet(rowKeys, tableView) {
    var flagStatus = 'NotFlagged';
    // Set the flag status to 'Flagged' if there is any non-flagged conversation
    for (var i = 0; i < rowKeys.length; i++) {
        var rowFlagStatus = MailRowDataPropertyGetter.getFlagStatus(rowKeys[i], tableView);
        if (rowFlagStatus != 'Flagged') {
            flagStatus = 'Flagged';
            break;
        }
    }
    return flagStatus;
}
/**
 * Toggle the given rows' flagged state
 * @param rowKeys the given rowkeys
 * @param tableViewId of the table that the row belong to
 */
export default action('toggleRowsFlagState')(function toggleRowsFlagState(rowKeys, tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    var flagStatusToSet = getFlagStatusToSet(rowKeys, tableView);
    setMailListRowsFlagState(rowKeys, tableViewId, flagStatusToSet);
});
//# sourceMappingURL=toggleRowsFlagState.js.map